import { type UseCase, isRoomFamily, liveUseCasesWhere } from './useCases';

/**
 * The room family: the use cases of the space template (`isRoomFamily`,
 * `utils/useCases.ts`), whose rooms are assigned to customer organizations and
 * booked through the path that applies coverage (`orders/from-reservation`,
 * the series core). Same set as `COVERABLE_SERVICES` in
 * new-backend/admin/src/lib/memberCoverage.ts — change both together.
 */

/** The room use cases this tenant runs, in description order. */
export const roomUseCasesOf = (services: string[] | null | undefined): UseCase[] =>
    liveUseCasesWhere((d) => d.template === 'space')
        .filter((useCase) => (services ?? []).some((s) => s.toLowerCase() === useCase));

/** Is this group a room by its compartment types? */
export const isRoomCell = (compartmentTypes: string[] | null | undefined): boolean =>
    (compartmentTypes ?? []).some((type) => isRoomFamily(String(type)));

/**
 * Does "Objekt erstellen" open the single-object create page (Flow 1) for this
 * tenant's services? Yes as soon as it runs one room use case; otherwise the
 * station wizard (Flow 2, `docs/plans/object-and-station-creation-flow.md` §3).
 */
export const opensSingleObjectCreate = (services: string[] | null | undefined): boolean =>
    roomUseCasesOf(services).length > 0;
